export class InstaPromoModel {
    promoItemId: string;
    promoTitle: string;
    instaPromoImageModel: InstaPromoImageModel;
    instaStoryContentModel: InstaStoryContentModel[];
    viewed: boolean;
}

export class InstaPromoImageModel {
    src: string;
    alt: string;
    width: number;
    height: number;
}

export class InstaStoryContentModel {
    mainStoryContentPath: string;
    mainStoryItemName: string;
    swipeUpContentPath: string;
    swipeUpItemName: string;
    enableSwipeUp: boolean;
    viewed: boolean;
    targetPromoId: string;
    targetPromoType: string;
    targetPromoStatus: string;
}
